import { useEffect, useMemo, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";
import { BusinessState } from "redux-context/business";
import { SubscriptionType } from "enums/SubscriptionType";
import { PopupModal } from "react-calendly";
import { foodInfluencersCollabLink } from "helpers/calendly-helper";
import { isMobile } from "react-device-detect";
import "./SupportStickyBar.scss";

type SupportStickyBarProps = {
  height: number;
  mobileTopOffset?: number;
  visibility?: "always" | "freemium";
};

const SupportStickyBar: React.FC<SupportStickyBarProps> = ({
  height,
  mobileTopOffset = 0,
  visibility = "freemium",
}) => {
  const { subscription, business } = useSelector(
    (state: BusinessState) => state.business,
  );
  const [isOpen, setIsOpen] = useState(false);

  const freemium =
    subscription?.subscriptionType === SubscriptionType.Fremium;
  const shouldRender = visibility === "always" || freemium;

  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "";

    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  const rootElement = useMemo(() => {
    if (typeof document === "undefined") {
      return null;
    }

    return (document.getElementById("root") || document.body) as HTMLElement;
  }, []);

  if (!shouldRender || !rootElement) {
    return null;
  }

  return (
    <>
      <div
        className="support-sticky-bar"
        style={{ height, top: isMobile ? mobileTopOffset : 0 }}
      >
        <FontAwesomeIcon icon={faPhone} className="support-sticky-bar__icon" />
        <span className="support-sticky-bar__text">
          Need help?{" "}
          <button
            type="button"
            className="support-sticky-bar__cta"
            onClick={() => setIsOpen(true)}
          >
            Book A Call
          </button>
        </span>
      </div>

      <PopupModal
        url={foodInfluencersCollabLink}
        open={isOpen}
        onModalClose={() => setIsOpen(false)}
        rootElement={rootElement}
        prefill={{
          name: business?.contactPersonFullName || "",
          email: business?.contactPersonEmail || "",
          customAnswers: {
            a2: business?.businessName || "",
            a3: business?.venues?.[0]?.addressDisplay || "",
            a5:
              business?.venues?.[0]?.instagramUrl ||
              business?.venues?.[0]?.tiktokUrl ||
              "",
          },
        }}
      />
    </>
  );
};

export default SupportStickyBar;
